import { ProductCardProps } from '../../home/types/types';
import ProductCard from '../../home/components/ProductCard';
import React from 'react';
import { useBreakpoint } from '../../hooks/useBreakpoint';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import SectionHeader, { SectionHeaderProps } from '../../home/components/SectionHeader';
import Button from '../../components/buttons/SimpleButton/Button';
import useViewItemListEvent from '../../hooks/useViewItemListEvent';

export interface ProductsBlockProps {
  products?: ProductCardProps[];
  button?: {
    label: string;
    url?: string;
    onClick?: () => void;
    loading?: boolean;
  };
  viewAll?: {
    label: string;
    url: string;
  };
  mobileView?: 'swiper' | 'block';
  sectionHeader?: SectionHeaderProps;
  advertisementPosition?: number;
  grid?: 'single' | 'double' | 'triple' | 'quad';
}

const ProductsBlock: React.FC<ProductsBlockProps> = ({
  products,
  button,
  mobileView = 'block',
  sectionHeader,
  advertisementPosition,
  grid = 'quad',
}) => {
  const { isExtraSmall, isSmall, isMedium } = useBreakpoint();
  const isMobile = isExtraSmall || isSmall || isMedium;

  useViewItemListEvent('view_item_list', sectionHeader?.blockId || '', sectionHeader?.title || '', products);

  const renderProductOrAd = (product: ProductCardProps, index: number) => {
    if (advertisementPosition && index === advertisementPosition - 1) {
      return <h1>AD</h1>;
    }
    return <ProductCard key={index} {...product} />;
  };

  return (
    <div className="e-com__products-block">
      {sectionHeader && <SectionHeader {...sectionHeader} />}

      {isMobile && mobileView === 'swiper' ? (
        <div className="e-com__products-mobile-swiper">
          <Swiper spaceBetween={16} slidesPerView={1.3}>
            {products?.map((product, index) => (
              <SwiperSlide key={index}>{renderProductOrAd(product, index)}</SwiperSlide>
            ))}
          </Swiper>
        </div>
      ) : (
        <div className={`e-com__products e-com__products--${grid}`}>
          {products?.map((product, index) => renderProductOrAd(product, index))}
        </div>
      )}

      {button?.label && (
        <div className="e-com__button-container">
          {button.onClick ? (
            <Button
              label={button.label}
              onClick={button.onClick}
              isDisabled={button.loading}
              className=""
              type="primary"
              size="large"
            />
          ) : (
            <a href={button.url} className="button button--primary button--large">
              {button.label}
            </a>
          )}
        </div>
      )}
    </div>
  );
};

export default ProductsBlock;
